import { FC, useMemo } from "react";
//#region types
import { NetOrBenefitIndicatorProps } from "models/propTypes/wintSalaryPropTypes";
import { WintSalaryEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Avatar, Tooltip } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const NetOrBenefitIndicator: FC<NetOrBenefitIndicatorProps> = (props) => {
  const label = useMemo(
    () =>
      props.type === WintSalaryEnums.NetOrBenefitIndicatorType.Net
        ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.NetSalary)
        : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.Benefit),
    [props.type]
  );

  return (
    <Tooltip
      disableInteractive
      placement="top"
      title={label}
      arrow
      classes={{
        tooltip: cssExports.tooltip,
        popper: cssExports.tooltipPopper,
        arrow: cssExports.tooltipArrow,
      }}
    >
      <Avatar className={clsx(cssExports.netOrBenefitIndicator, props.className)}>
        {label.trim().charAt(0)}
      </Avatar>
    </Tooltip>
  );
};

export default NetOrBenefitIndicator;
